import { render, staticRenderFns } from "./Escalate.vue?vue&type=template&id=6e9604a0&scoped=true&"
import script from "./Escalate.vue?vue&type=script&setup=true&lang=js&"
export * from "./Escalate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9604a0",
  null
  
)

export default component.exports